import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { AppInitializationService } from 'app/app-initialization.service';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { UserService } from 'app/services/user.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserFormComponent } from '../user-form/user-form.component';

@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class UserListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _userList: Array<User> = [];
    public userId:number;
    public companyId:number;
 
    public get userList(): Array<User> {
        return this._userList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<User> = undefined;
    public get dataSource(): MatTableDataSource<User> {
        return this._dataSource;
    }

    private _displayedColumns = ['name', 'title', 'userName','role','picture', 'active', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _dialog: MatDialog,
        private _spinner: NgxSpinnerService,
        private _toastService: ToasterService,
        private _userService: UserService,
        private appConfigService:AppInitializationService
    ) {
    }


    public async ngOnInit() {
        try {

            this.companyId=parseInt(localStorage.getItem("CompanyID"))
            this.userId=parseInt(localStorage.getItem("UserID"))
            
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            
        }
        await this.getUserList();
    }
    private async getUserList(): Promise<Array<User>> {
        try {
            this._spinner.show('loading')
            this._userList = await this._userService.getUserCompany(this.companyId);            
            this._spinner.hide('loading')

            if (parseInt(localStorage.getItem("RoleID"))!= -1) {// is not super admin
                this._userList = this._userList.filter(x => x.role != -1)
            }
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<User>(this._userList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public addUser() {
        const dialog = this._dialog.open(UserFormComponent, {
            data: new User(),
            disableClose: false
        });
        dialog.componentInstance.operation = "create"
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public updateUser(userby:User) {
        const dialog = this._dialog.open(UserFormComponent, {
            data: cloneDeep(userby),
            disableClose: false
        });
        dialog.componentInstance.model = cloneDeep(userby);
        dialog.componentInstance.operation = "update"
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public async deleteUser(user: User) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen kullanıcıyı silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{                     
                await this._userService.delete(user);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })

        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
        await this.refresh();
    }

    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    
    async refresh() {
        await this.getUserList();
    }

}
